/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import request, { ContentType, RequestParams } from './httpClient'
import {
  DomainOrder,
  DomainOrderChangeAmountReq,
  DomainOrderListResp,
  GetAdminOrderExportParams,
  GetAdminOrderListParams,
  WebResp,
} from './types'

/**
 * @description 订单列表
 *
 * @tags AdminOrderV1
 * @name GetAdminOrderList
 * @summary 订单列表
 * @request GET:/api/v1/admin/order
 * @response `200` `(WebResp & {
    data?: DomainOrderListResp,

})` OK
 */

export const getAdminOrderList = (query: GetAdminOrderListParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainOrderListResp
    }
  >({
    path: `/api/v1/admin/order`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 修改订单金额
 *
 * @tags AdminOrderV1
 * @name PostAdminOrderChangeAmount
 * @summary 修改订单金额
 * @request POST:/api/v1/admin/order/change_amount
 * @response `200` `(WebResp & {
    data?: unknown,

})` OK
 */

export const postAdminOrderChangeAmount = (param: DomainOrderChangeAmountReq, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: unknown
    }
  >({
    path: `/api/v1/admin/order/change_amount`,
    method: 'POST',
    body: param,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 导出订单CSV文件
 *
 * @tags AdminOrderV1
 * @name GetAdminOrderExport
 * @summary 导出订单
 * @request GET:/api/v1/admin/order/export
 * @response `200` `File` 订单数据CSV文件
 */

export const getAdminOrderExport = (query: GetAdminOrderExportParams, params: RequestParams = {}) =>
  request<File>({
    path: `/api/v1/admin/order/export`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    ...params,
  })

/**
 * @description 订单详情
 *
 * @tags AdminOrderV1
 * @name GetAdminOrderInfo
 * @summary 订单详情
 * @request GET:/api/v1/admin/order/{order_code}
 * @response `200` `(WebResp & {
    data?: DomainOrder,

})` OK
 */

export const getAdminOrderInfo = (orderCode: string, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainOrder
    }
  >({
    path: `/api/v1/admin/order/${orderCode}`,
    method: 'GET',
    type: ContentType.Json,
    format: 'json',
    ...params,
  })
